<app-no-data-to-display
    [displayedMessage]="'errorForbidden'"
    [iconSize]="'5x'" />
